module.exports = __webpack_public_path__ + "img/08-ค่างวด.b73211ff.png";